import React, { useEffect, useState } from "react";

import { Button, TextArea } from "@fronterahealth/frontera-ui-components";

import { MediaCommentsType, useUpdateMediaCommentMutation } from "@api/graphql/types-and-hooks";
import { convertMediaCommentToComment } from "@pages/VideoSessionsV2/components/Comments/helper";
import { useVideoSessionData } from "@providers/VideoSessionProviderV2";

interface CommentEditFormProps {
  commentId: string;
  existingContent: string;
  handleCommentSubmit?: () => void;
}
const CommentEditForm: React.FC<CommentEditFormProps> = ({ commentId, existingContent }) => {
  const { setEditingCommentId, setAllFilteredComments } = useVideoSessionData();
  const [comment, setComment] = useState<string>("");

  const updateCommentMutation = useUpdateMediaCommentMutation();
  const { isPending } = updateCommentMutation;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(event.target.value);
  };
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (comment.trim()) {
      await updateCommentMutation
        .mutateAsync({
          input: {
            commentId,
            content: comment,
          },
        })
        .then((data) => {
          if (data.updateMediaComment?.status) {
            setAllFilteredComments((prevComments) => {
              const updatedComment = convertMediaCommentToComment(
                data.updateMediaComment?.mediaComment as MediaCommentsType,
              );
              return prevComments.map((comment) => {
                if (comment.id === updatedComment.parentCommentID) {
                  return {
                    ...comment,
                    lastReply:
                      comment.lastReply?.map((reply) =>
                        reply.id === updatedComment.id ? { ...reply, ...updatedComment } : reply,
                      ) ?? [],
                  };
                } else if (comment.id === updatedComment.id) {
                  return {
                    ...comment,
                    ...updatedComment,
                  };
                }
                return comment;
              });
            });
            setEditingCommentId(null);
          }
        });
    }
  };

  useEffect(() => {
    setComment(existingContent);
  }, [existingContent]);

  return (
    <form onSubmit={handleSubmit} className="relative w-full flex flex-col gap-2">
      <TextArea
        label=""
        name="comment"
        value={comment}
        onChange={handleChange}
        placeholder="Leave your comment..."
        required
        formNoValidate
        rows={2}
      />

      <div className="flex flex-row w-full justify-end gap-2 mt-1">
        <Button text="Cancel" appearance="text" onClick={() => setEditingCommentId(null)} />
        <Button type="submit" disabled={!comment.trim() || isPending} text="Save" appearance="primary" />
      </div>
    </form>
  );
};

export default CommentEditForm;
